import React, {useEffect, useState} from 'react';
import {
    Button,
    Popup,
    Flex,
    Goods,
    IconButton,
    Tabs,
    Tab,
    Price,
    Tag,
    // Search,
    Empty,
    FlexItem
} from '@chatui/core';


function GoodsSelect(props) {

    const [goodsList, setGoodsList] = useState({});
    const [categories, setCategories] = useState(Object.keys(goodsList));
    const [initSelectedGoods, setInitSelectedGoods] = useState({}) //

    const [selectedGoods, setSelectedGoods] = useState(initSelectedGoods);
    const [goodsNum, setGoodsNum] = useState(0);
    const [openCart, setOpenCart] = useState(false);
    const [sumPrice, setSumPrice] = useState(0);

    const SelectGoods = (category, index) => {
        // console.log(selectedGoods);
        console.log(selectedGoods, category, index)
        const newSelectedGoods = JSON.parse(JSON.stringify(selectedGoods));
        if (!newSelectedGoods[category][index]) {
            newSelectedGoods[category][index] = 1
        }
        else {
            newSelectedGoods[category][index] += 1
        }
        setSelectedGoods(newSelectedGoods);
        setGoodsNum(goodsNum+1);
        setSumPrice(sumPrice+parseFloat(goodsList[category][index].price));
    }

    const onAcknowledge = () => {
        const gl = [];
        for (let k=0; k<categories.length; k++) {
            const idxes = Object.keys(selectedGoods[categories[k]]);
            for(let i in idxes) {
                let g = {...goodsList[categories[k]][idxes[i]]};
                g['count'] = selectedGoods[categories[k]][idxes[i]];
                gl.push(g);
            }
        }
        if (props.onAcknowledge) {
            props.onAcknowledge(gl);
        }
        clearCart();
    }

    const clearCart = () => {
        setSelectedGoods(initSelectedGoods);
        setSumPrice(0);
        setGoodsNum(0);
    };

    const getGoodsList = () => {
        if (props.getGoodsList) {
            props.getGoodsList()
                .then(gl=>{

                    setGoodsList(gl);
                    const newInitSelectedGoods = {}
                    const newCategories = Object.keys(gl)
                    for (let k in newCategories) {
                        newInitSelectedGoods[newCategories[k]] = {}
                    }

                    setInitSelectedGoods(newInitSelectedGoods);
                    setCategories(newCategories);
                    setSelectedGoods(newInitSelectedGoods);
                })
                .catch(error=>{
                    console.log(error);
                });
        }
    }
    useEffect(() => {
        getGoodsList();
    }, []);
    return (
        // <div>
            <Popup
                active={props.active}
                onClose={props.onClose? props.onClose: ()=>{}}
                title={props.title}
                height={80}
            >

                {Object.keys(goodsList).length>0? (
                    <div>
                        <Popup
                            active={openCart}
                            onClose={()=>setOpenCart(false)}
                            title={props.cartText}
                            height={40}
                        >
                            <IconButton size={'lg'}
                                        style={{'position': 'fixed', 'right': '50px', 'top':'18px'}}
                                        icon={'dash-circle-fill'}
                                        onClick={()=>clearCart()}
                            ></IconButton>
                            {categories.map((category, c_index)=>(

                                Object.keys(selectedGoods[category]).map((k, index)=>(
                                    <Goods
                                        key={c_index.toString()+index.toString()}
                                        type={'products'}
                                        name={goodsList[category][index].name}
                                        price={goodsList[category][index].price}
                                        desc={goodsList[category][index].desc}
                                        count={selectedGoods[category][index]}
                                        img={goodsList[category][index].img}
                                        currency={props.currency}
                                    ></Goods>
                                    )
                                )
                            ))}
                        </Popup>
                        {/*<Search placeholder={'Input key words of target products...'}></Search>*/}
                        <Tabs scrollable>
                            {Object.keys(goodsList).map((category, index)=>(
                            <Tab label={category} key={index}>
                                {goodsList[category].map((item, goods_idx)=>(
                                    <Goods
                                        key={goods_idx}
                                        type={'products'}
                                        name={item.name}
                                        price={item.price}
                                        desc={item.desc}
                                        img={item.img}
                                        currency={props.currency}
                                        action={{icon: 'cart', onClick: ()=>SelectGoods(category, goods_idx)}}
                                    ></Goods>
                                ))}
                            </Tab>
                        ))}
                        </Tabs>
                        <Flex center style={{
                            "position": "fixed",
                            "bottom": "0px",
                            'backgroundColor': '#f1f1f1',
                            "width": "100%",
                            'height': '50px'
                        }}>
                            <FlexItem>
                            <Button size={"lg"}
                                    icon={'shopping-bag-fill'}
                                    style={{"width": "80px"}}
                                    onClick={() => setOpenCart(true)}
                            >
                                {goodsNum <= 0 ? '' : (
                                    <Tag color={'primary'}>
                                        {goodsNum}
                                    </Tag>
                                )}
                            </Button>
                            </FlexItem>
                            <FlexItem>
                                {props.totalPriceText} <Price style={{'fontSize': '1.2em'}} price={sumPrice} currency={props.currency} />
                            </FlexItem>

                            <Button onClick={onAcknowledge} size={'lg'}>Okay</Button>
                        </Flex>
                    </div>
                ):(
                    <Empty type="error" tip="oops.. Failed to load, click to reload">
                        <Button onClick={()=>getGoodsList()} color="primary">Refresh</Button>
                      </Empty>
                )}

            </Popup>

    );
}

export default GoodsSelect;